import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import Toggle from './../Toggle'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView02ImageOptions } from './views/InteriorView02'

class X46MK2Saloon extends Component {
  constructor (props) {
    super(props)
    this.handleTableBoxChange = this.handleTableBoxChange.bind(this)
    this.handlePouffesChange = this.handlePouffesChange.bind(this)
  }

  handleTableBoxChange (event) {
    const configuration = this.props.configuration
    configuration.TableBox = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handlePouffesChange (event) {
    const configuration = this.props.configuration
    configuration.Pouffes = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <X46MK2InteriorConfiguratorImage
        boat='X46MK2'
        configuration={this.props.configuration}
        options={interiorView02ImageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Saloon' />
          </h1>
          <h2>
            <Trans defaults='Furniture' />
          </h2>
          <p>
            <Trans defaults='You can choose to have a luxury table inclusive bottle box and exclusive table top surface, and a pouffe for extra seats at the table.' />
          </p>
          <p>
            <Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint.' />
          </p>

          <Toggle
            checked={this.props.configuration.TableBox.value === 2}
            onChange={this.handleTableBoxChange}
          >
            <Trans defaults='Table box' />
          </Toggle>

          <Toggle
            checked={this.props.configuration.Pouffes.value === 2}
            onChange={this.handlePouffesChange}
          >
            <Trans defaults='Pouffe' />
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Saloon)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Saloon.js